/* unplugin-vue-components disabled */import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "patrol-scheme-complete"
};
var _hoisted_2 = {
  class: "list-detail"
};
var _hoisted_3 = {
  class: "list-detail-block"
};
var _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "detail-item-title"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "detail-item-title-icon"
}), /*#__PURE__*/_createElementVNode("div", null, "保养情况")], -1);
var _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "img-label"
}, "图片", -1);
var _hoisted_6 = {
  class: "bottom-submit"
};
import { uploadImage, delImage } from '@/service/patrolGuard/index';
import { postAddPatrolGuard } from '@/service/patrolGuard/index';
import { showToast } from 'vant';
import './complete.less';
import './common.less';
export default /*#__PURE__*/_defineComponent({
  __name: 'Complete',
  setup: function setup(__props) {
    var router = useRouter();
    var route = useRoute();
    var _route$query = route.query,
      id = _route$query.id,
      taskItemId = _route$query.taskItemId;
    var formRef = ref('');
    var value = ref([]);
    var inspectionContent = ref('');
    var loading = ref(false);
    var imgIdList = ref([]);
    var beforePath = ref('');
    // 上传图片
    var ImgUploadFile = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(fileList) {
        var formData, data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              // 要把数据变成file格式
              console.log(fileList, 'fileList');
              formData = new FormData();
              fileList.map(function (item) {
                formData.append('file', item.file);
              });
              _context.next = 6;
              return uploadImage(formData);
            case 6:
              data = _context.sent;
              return _context.abrupt("return", Promise.resolve(data.list));
            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](0);
              return _context.abrupt("return", Promise.reject());
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 10]]);
      }));
      return function ImgUploadFile(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    var beforeRead = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(file) {
        var status, reg;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              status = Array.isArray(file);
              reg = /png$|jpeg$|gif$|jpg$/;
              return _context2.abrupt("return", new Promise(function (resolve, reject) {
                var imgFlag = 0;
                if (status) {
                  file.map(function (item) {
                    if (!reg.test(item.type)) {
                      imgFlag++;
                    }
                  });
                } else {
                  if (!reg.test(file.type)) {
                    imgFlag++;
                  }
                }
                if (imgFlag) {
                  showToast('仅支持上传图片！');
                  return reject(false);
                }
                return resolve();
              }));
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function beforeRead(_x2) {
        return _ref2.apply(this, arguments);
      };
    }();
    var afterRead = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(file) {
        var status, list, fileList;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              status = Array.isArray(file);
              _context3.prev = 1;
              list = [];
              if (!status) {
                _context3.next = 11;
                break;
              }
              fileList = [];
              file.map(function (item) {
                fileList.push(item);
                item.status = 'uploading';
                item.message = '上传中...';
              });
              _context3.next = 8;
              return ImgUploadFile(fileList);
            case 8:
              list = _context3.sent;
              _context3.next = 16;
              break;
            case 11:
              file.status = 'uploading';
              file.message = '上传中...';
              _context3.next = 15;
              return ImgUploadFile([file]);
            case 15:
              list = _context3.sent;
            case 16:
              list.map(function (item) {
                imgIdList.value.push(item.attachment_id);
              });
              if (status) {
                list.map(function (item, index) {
                  file[index].id = item.attachment_id;
                  file[index].message = '上传成功';
                  file[index].status = 'successed';
                });
              } else {
                file.id = list[0]['attachment_id'];
                file.message = '上传成功';
                file.status = 'successed';
              }
              showToast('上传成功');
              _context3.next = 25;
              break;
            case 21:
              _context3.prev = 21;
              _context3.t0 = _context3["catch"](1);
              file.status = 'failed';
              file.message = '上传失败';
            case 25:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[1, 21]]);
      }));
      return function afterRead(_x3) {
        return _ref3.apply(this, arguments);
      };
    }();
    var delImg = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(file) {
        var index;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              index = imgIdList.value.findIndex(function (item) {
                return item == (file === null || file === void 0 ? void 0 : file.id);
              });
              imgIdList.value.splice(index, 1);
              _context4.next = 5;
              return delImage(file === null || file === void 0 ? void 0 : file.id);
            case 5:
              _context4.next = 10;
              break;
            case 7:
              _context4.prev = 7;
              _context4.t0 = _context4["catch"](0);
              console.log(_context4.t0);
            case 10:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[0, 7]]);
      }));
      return function delImg(_x4) {
        return _ref4.apply(this, arguments);
      };
    }();
    onActivated(function () {
      console.log(1);
    });
    // const onClickLeft = () => {
    //   router.back();
    // };
    var onSubmit = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var res, timer;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              loading.value = true;
              _context5.next = 4;
              return formRef.value.validate();
            case 4:
              _context5.next = 6;
              return postAddPatrolGuard({
                taskType: 1,
                dateSource: 2,
                deviceId: Number(id),
                inspectionContent: inspectionContent.value,
                inspectionItemId: taskItemId || null,
                inspectionHistoryAttachmentIdList: imgIdList.value
              });
            case 6:
              res = _context5.sent;
              loading.value = false;
              if (res.status == '1') {
                showToast.success("\u5B8C\u6210\u6210\u529F");
              } else {
                showToast("\u5B8C\u6210\u5931\u8D25");
              }
              timer = setTimeout(function () {
                clearTimeout(timer);
                console.log(beforePath.value);
                router.back();
              }, 500);
              _context5.next = 15;
              break;
            case 12:
              _context5.prev = 12;
              _context5.t0 = _context5["catch"](0);
              loading.value = false;
            case 15:
            case "end":
              return _context5.stop();
          }
        }, _callee5, null, [[0, 12]]);
      }));
      return function onSubmit() {
        return _ref5.apply(this, arguments);
      };
    }();
    onMounted(function () {
      //
    });
    return function (_ctx, _cache) {
      var _component_van_field = _resolveComponent("van-field");
      var _component_van_uploader = _resolveComponent("van-uploader");
      var _component_van_form = _resolveComponent("van-form");
      var _component_van_button = _resolveComponent("van-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createVNode(_component_van_form, {
        onSubmit: onSubmit,
        ref_key: "formRef",
        ref: formRef
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_van_field, {
            rows: "3",
            autosize: "",
            required: "",
            label: "保养情况",
            type: "textarea",
            placeholder: "请输入",
            modelValue: _unref(inspectionContent),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return _isRef(inspectionContent) ? inspectionContent.value = $event : null;
            }),
            rules: [{
              required: true,
              message: '请输入保养情况'
            }]
          }, null, 8, ["modelValue"]), _hoisted_5, _createVNode(_component_van_field, {
            name: "uploader",
            class: "image-uploader"
          }, {
            input: _withCtx(function () {
              return [_createVNode(_component_van_uploader, {
                modelValue: _unref(value),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                  return _isRef(value) ? value.value = $event : null;
                }),
                "after-read": afterRead,
                "before-read": beforeRead,
                "max-count": "9",
                multiple: "",
                onDelete: delImg
              }, null, 8, ["modelValue"])];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 512)])]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_van_button, {
        round: "",
        block: "",
        type: "primary",
        loading: _unref(loading),
        onClick: onSubmit
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(" 确定 ")];
        }),
        _: 1
      }, 8, ["loading"])])]);
    };
  }
});